<!--
 * @Description: 请输入当前文件描述
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-04-07 16:01:37
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-07 16:09:52
 -->
<template>
  <div class="mainFunction">
    <div class="titleHeader">
        <img src="/static/img/layout/arrow-orange.png" alt="">
        <span class="titleName">主要功能</span>
      </div>
      <div class="content"></div>
  </div>
</template>

<script>
export default {
  name: 'mainFunction',
  components: {
  },
  data () {
    return {
    }
  },
  methods: {
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .mainFunction {
    width: 100%;
    height: 100%;
    .titleHeader {
      width: 100%;
      height: 40px;
      font-size: 20px;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      >img {
        height: 100%;
        margin-right: 20px;
        vertical-align: middle;
      }
      .titleName {
        vertical-align: middle;
        display: inline-block;
        color: #05dbe3;
        height: 40px;
        line-height: 40px;
      }
    }
    .content {
      width: 96%;
      height: calc(100% - 160px);
      border-radius: 6px;
      background: url('/static/img/layout/truck.png');
      background-size: 100% 100%;
      margin-top: 30px;
    }
  }
</style>
